// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.valign-center {
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
}

a {
  text-decoration: none;
  color: white;
}

a:hover {
  color: rgb(185, 24, 24);
}

.menu-items {
  margin: 0;
  padding: 0;
  list-style: none;
}

mat-toolbar {
  top: 0px;
  z-index: 999;
}

mat-icon {
  cursor: pointer;
}

mat-icon:hover {
  color: firebrick;
}

mat-divider {
  background-color: white;
}

.mat-toolbar-single-row {
  height: 45px;
}

.drop-down-icon {
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navigation/navigation.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,qBAAA;EACA,YAAA;AACJ;;AAEE;EACE,uBAAA;AACJ;;AAEE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AACJ;;AAEE;EACE,QAAA;EACA,YAAA;AACJ;;AAEE;EACI,eAAA;AACN;;AAEE;EACI,gBAAA;AACN;;AAEE;EACI,uBAAA;AACN;;AAEE;EACE,YAAA;AACJ;;AAEE;EACE,sBAAA;AACJ","sourcesContent":[".valign-center {\n    display: inline-flex;\n    vertical-align: middle;\n    align-items: center;\n  }\n  \n  a {\n    text-decoration: none;\n    color: white;\n  }\n  \n  a:hover {\n    color: rgb(185, 24, 24);\n  }\n  \n  .menu-items {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n  \n  mat-toolbar {\n    top: 0px;\n    z-index: 999;\n  }\n\n  mat-icon {\n      cursor: pointer;\n  }\n\n  mat-icon:hover {\n      color: firebrick;\n  }\n\n  mat-divider {\n      background-color: white;\n  }\n\n  .mat-toolbar-single-row {\n    height: 45px;\n  }\n\n  .drop-down-icon {\n    vertical-align: middle;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
